


















































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import { fetchSimSolicitudes } from './fetchSimSolicitudes';
import ComponenteDialogoEdicion from './ComponenteDialogoEdicion.vue';

import { headers } from '@/pantallas/Conecta/SIMSolicitudes/headersSimSolicitudes';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ValueFormatterParams,
  GetQuickFilterTextParams,
  RowNode,
} from 'ag-grid-community';

import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import CabeceraModalCrear from '@/reusable/Modal/CabeceraModalCrear.vue';
import NavegacionModalCrud from '@/reusable/Mantenedor/NavegacionModalCrud.vue';
import CrudStepperHeader from '@/reusable/Mantenedor/CrudStepperHeader.vue';
import CrudStepperItems from '@/reusable/Mantenedor/CrudStepperItems.vue';
import CrudStepperContent from '@/reusable/Mantenedor/CrudStepperContent.vue';

import { LoadingService } from '@/services/loadingService';
import { utils, writeFileXLSX } from 'xlsx';
import moment from 'moment';

import { actionsEvent } from '@/setup';
import CabeceraModalSimVista from './CabeceraModalSimVista.vue';
import VerDetalleSimSolicitudes from './VerDetalleSimSolicitudes.vue';

@Component({
  components: {
    ComponenteDialogoEdicion,
    ModalMantenedor,
    CabeceraModalCrear,
    NavegacionModalCrud,
    CrudStepperHeader,
    CrudStepperItems,
    CrudStepperContent,
    MantenedorGridSinCodigo,
    CabeceraModalSimVista,
    VerDetalleSimSolicitudes,
  },
})
export default class TablaSimSolicitudes extends Vue {
  constructor() {
    super();
    actionsEvent.onEditar(this.handleEditar);
    actionsEvent.onVerDetalle(this.handleDetalle);
  }
  @Prop({ default: [] }) solicitudes: any;
  @Prop({ default: '' }) busqueda: string;
  mostrarDetalle: boolean = false;

  usuarioID = JSON.parse(localStorage.getItem('user')).id;
  abrirModal = false;
  mostrarLecturaExcel = false;
  pasoActivoIndex = 1;
  dialogConfirmacionGuardar = false;
  mensajeConfirmacion: any = '';
  idEstadoParaAnular = 0;
  pageConfig = {
    rowsPerPage: 25,
  };

  mostrarBtnVolver = false;
  mostrarBtnContinuar = true;
  mostrarBtnGuardar = false;
  permitirCont = true;
  permitirGuard = false;

  loadingService = new LoadingService();
  $snotify: any;

  handleEditar(e: any) {
    this.dataSolicitud(e.data);
    this.abrirModal = true;
  }
  reporteSelected: any;
  numeroSelected: any;
  handleDetalle(e: any) {
    if (!e.data.reporte_crm || e.data.reporte_crmo == '') {
      this.$snotify.error('El ingreso de SIM no ha sido cargado a CRM', 3000);
      return;
    }
    this.reporteSelected = e.data.reporte_crm;
    this.numeroSelected = e.data.simingresonumero;
    this.mostrarDetalle = true;
  }

  // tabla //
  gridApi: GridApi = null;
  enrichedGridOptions: GridOptions = null;
  readonly funcionalidad: Funcionalidades = Funcionalidades.SimSolicitudes;
  readonly gridOptions: GridOptions = {
    columnDefs: headers,
    onGridReady: this.handleGridReady,
    isExternalFilterPresent: this.isExternalFilterPresent,
    doesExternalFilterPass: this.doesExternalFilterPass,
    paginationPageSize: 30,
    processCellForClipboard: ({ value }) => {
      return value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value;
    },
  };
  handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.gridApi.setRowData(this.solicitudes);
    this.gridApi.setDomLayout('autoHeight');
  }
  fechaValueFormatter(params: ValueFormatterParams) {
    return this.formatFecha(params.value);
  }
  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }
  fechaQuickFilterGetter(params: GetQuickFilterTextParams) {
    return this.formatFecha(params.value);
  }
  doesExternalFilterPass(node: RowNode): boolean {
    let nd = node.data;
    if (this.solicitudes.length > 0 && this.busqueda.length > 0) {
      let search =
        nd.simingresonumero
          .toLowerCase()
          .includes(this.busqueda.toLowerCase()) ||
        nd.nombreUsuarioCompleto
          .toLowerCase()
          .includes(this.busqueda.toLowerCase()) ||
        nd.simingresofecha_alta
          .toLowerCase()
          .includes(this.busqueda.toLowerCase()) ||
        nd.numeroreportesim
          .toLowerCase()
          .includes(this.busqueda.toLowerCase()) ||
        nd.telconame.toLowerCase().includes(this.busqueda.toLowerCase()) ||
        nd.telcoplanname.toLowerCase().includes(this.busqueda.toLowerCase()) ||
        nd.simingresoestadoColor
          .toLowerCase()
          .includes(this.busqueda.toLowerCase()) ||
        nd.simingresocant.toLowerCase().includes(this.busqueda.toLowerCase()) ||
        nd.reporte_crm.toLowerCase().includes(this.busqueda.toLowerCase()) ||
        nd.ingresocrm_estado
          .toLowerCase()
          .includes(this.busqueda.toLowerCase()) ||
        nd.ingresocrm_estado
          .toLowerCase()
          .includes(this.busqueda.toLowerCase()) ||
        nd.simingresocant_cargada
          .toLowerCase()
          .includes(this.busqueda.toLowerCase()) ||
        nd.tipoubicaname.toLowerCase().includes(this.busqueda.toLowerCase());
      return search;
    }
    return true;
  }
  isExternalFilterPresent(): boolean {
    return true;
  }
  // fin tabla //

  infoSolicitud = {
    destino: '',
    cantSims: 0,
    fecha: '',
    numero: 0,
    plan: '',
    telco: '',
    usuario: '',
    estado: '',
  };

  dataSolicitud(solicitud: any) {
    this.infoSolicitud.numero = solicitud.simingresonumero;
    this.infoSolicitud.fecha = solicitud.simingresofecha_alta;
    this.infoSolicitud.telco = solicitud.telconame;
    this.infoSolicitud.plan = solicitud.telcoplanname;
    this.infoSolicitud.cantSims = solicitud.simingresocant;
    this.infoSolicitud.destino = solicitud.tipoubicaname;
    this.infoSolicitud.estado =
      solicitud.simingresoestadoColor === '🟢 VIGENTE' ? 'VIGENTE' : 'ANULADO';
    this.infoSolicitud.usuario = solicitud.nombreUsuarioCompleto;
  }

  pasos: PasosCrud = {
    visualizarSolicitud: {
      accion: '',
      visible: true,
      step: 1,
      title: 'Visualizar y Editar Ingreso',
      icon: 'info',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
      codigoSubAccion: 40,
      codigoAccionPadre: CodigoAccion.Crear,
    },
  };

  cantidadPasos(cantidad: any) {
    if (cantidad === 1) {
      this.pasos = {
        visualizarSolicitud: {
          accion: '',
          visible: true,
          step: 1,
          title: 'Visualizar y Editar Ingreso',
          icon: 'info',
          formState: {
            entity: null,
            validator: null,
            isDirty: false,
          },
          codigoSubAccion: 40,
          codigoAccionPadre: CodigoAccion.Crear,
        },
      };
    }
    if (cantidad === 2) {
      this.pasos = {
        visualizarSolicitud: {
          accion: '',
          visible: true,
          step: 1,
          title: 'Visualizar y Editar Ingreso',
          icon: 'info',
          formState: {
            entity: null,
            validator: null,
            isDirty: false,
          },
          codigoSubAccion: 40,
          codigoAccionPadre: CodigoAccion.Crear,
        },
        descargaExcel: {
          accion: '',
          visible: true,
          step: 2,
          title: 'Descarga en Excel',
          icon: 'directions_car',
          codigoSubAccion: 41,
          codigoAccionPadre: CodigoAccion.Crear,
        },
      };
    }
  }

  exportarExcel() {
    this.loadingService.showLoading(undefined, 'exportarExcel');
    return fetchSimSolicitudes('downloadDataToExcel', {
      simingresonumero: this.infoSolicitud.numero,
    })
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          let headers = {
            header: [
              'SIM Serie Número',
              'SIM Prefijo',
              'SIM Móvil',
              'Fecha de Provisión',
              'SIM Tamaño',
              'SIM APN',
              'SIM Estado',
            ],
          };
          let lista = data.data.data;
          let datos: any = [];
          for (let item in lista) {
            datos.push({
              'SIM Serie Número': lista[item]['simserienumero'],
              'SIM Prefijo': lista[item]['simprefijo'],
              'SIM Móvil': lista[item]['simmovil'],
              'Fecha de Provisión': lista[item]['simprovision_fecha'].slice(
                0,
                10
              ),
              'SIM Tamaño': lista[item]['simtamanio'],
              'SIM APN': lista[item]['telcoapnname']
                ? lista[item]['telcoapnname']
                : '',
              'SIM Estado': lista[item]['configvalor'],
            });
          }
          const ws = utils.json_to_sheet(datos, headers);
          const wb = utils.book_new();
          utils.book_append_sheet(wb, ws, 'Registro SIM');
          writeFileXLSX(wb, `RegistroSIM-Nº${this.infoSolicitud.numero}.xlsx`);
          this.$snotify.success(data.data.MENSAJE_RESPUESTA, 3000);
        } else this.$snotify.warning(data.data.MENSAJE_RESPUESTA, 3000);
      })
      .catch((err: any) => console.error(err))
      .finally(() => this.loadingService.hideLoading('exportarExcel'));
  }

  estadoFueAnulado(fueAnulado: any) {
    if (fueAnulado.anular) {
      this.idEstadoParaAnular = fueAnulado.registroNumero;
      this.mostrarLecturaExcel = true;
      this.anularEstado();
      this.pasos = {
        visualizarSolicitud: {
          accion: '',
          visible: true,
          step: 1,
          title: 'Visualización de Solicitud',
          icon: 'info',
          formState: {
            entity: null,
            validator: null,
            isDirty: false,
          },
          codigoSubAccion: 40,
          codigoAccionPadre: CodigoAccion.Crear,
        },
      };
    } else {
      this.idEstadoParaAnular = fueAnulado.registroNumero;
      this.mostrarLecturaExcel = false;
      this.pasos = {
        visualizarSolicitud: {
          accion: '',
          visible: true,
          step: 1,
          title: 'Visualización de Solicitud',
          icon: 'info',
          formState: {
            entity: null,
            validator: null,
            isDirty: false,
          },
          codigoSubAccion: 40,
          codigoAccionPadre: CodigoAccion.Crear,
        },
        descargaExcel: {
          accion: '',
          visible: true,
          step: 2,
          title: 'Descarga en Excel',
          icon: 'directions_car',
          codigoSubAccion: 41,
          codigoAccionPadre: CodigoAccion.Crear,
        },
      };
    }
  }

  get estadoId() {
    const { entity } = this.pasos.visualizarSolicitud.formState;
    if (!entity) return null;
    return entity.estado;
  }

  modalContinuar() {
    this.mostrarLecturaExcel = true;
  }

  anularEstado() {
    this.loadingService.showLoading(undefined, 'handleGuardar');
    fetchSimSolicitudes('pasarEstadoAnulacion', {
      SIMIngresoNumero: this.idEstadoParaAnular,
      userId: this.usuarioID,
      clienteID: JSON.parse(localStorage.getItem('user')).clienteDefecto,
      moduloID: Funcionalidades.SimSolicitudes,
    })
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.$snotify.success(data.data.MENSAJE_RESPUESTA, 3000);
          this.idEstadoParaAnular = 0;
          this.$emit('rerenderTabla');
        } else {
          if (data.data.MENSAJE_RESPUESTA === 'NADA')
            this.$snotify.success('Guardar OK', 3000);
          else this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => {
        this.loadingService.hideLoading('handleGuardar');
        this.abrirModal = false;
      });
  }

  // cabecera Modal Custom //
  volv() {
    if (this.pasoActivoIndex == 2) {
      this.pasoActivoIndex = 1;
      this.mostrarLecturaExcel = false;
      this.mostrarBtnVolver = false;
      this.mostrarBtnContinuar = true;
      this.mostrarBtnGuardar = false;
    }
  }
  cont() {
    if (this.pasoActivoIndex == 1) {
      this.pasoActivoIndex = 2;
      this.mostrarLecturaExcel = true;
      this.mostrarBtnVolver = true;
      this.mostrarBtnContinuar = false;
      this.mostrarBtnGuardar = false;
    }
  }
  permitirSeguir() {
    this.permitirCont = true;
  }
  quitarGuardar() {
    this.permitirGuard = false;
  }
  // cabecera Modal Custom //

  cerrarModalVista() {
    this.abrirModal = false;
    this.pasoActivoIndex = 1;
    this.mostrarBtnVolver = false;
    this.mostrarBtnContinuar = true;
    this.mostrarBtnGuardar = false;
    this.permitirCont = true;
    this.permitirGuard = false;
  }

  async handleGuardar() {
    const isValid = await this.pasos.visualizarSolicitud.formState.validator.validateAll();
    if (isValid) {
      this.handleEstadoSwitch(
        this.pasos.visualizarSolicitud.formState.entity.estado
      );
      this.dialogConfirmacionGuardar = true;
    }
  }

  handleEstadoSwitch(isActivo: boolean) {
    if (!isActivo)
      this.mensajeConfirmacion =
        'Al dejar como inactivo, no se permitirá recibir notificaciones de esta Alerta. ¿Esta seguro que desea crear la Alerta?';
    else {
      this.mensajeConfirmacion = this.$t('mensajes.crud.crear.mensaje', {
        entidad: 'la Alerta',
      });
    }
  }

  @Watch('solicitudes')
  onPropertyChanged(value: boolean, oldValue: boolean) {
    if (value != oldValue) {
      this.gridApi.setRowData(this.solicitudes);
      this.gridApi.setDomLayout('autoHeight');
    }
  }

  @Watch('busqueda')
  onPropertySearchChanged(value: boolean, oldValue: boolean) {
    if (value != oldValue) {
      this.gridApi.onFilterChanged();
    }
  }
}
